import classNames from 'classnames'

import { EMPTY_OBJECT } from '../../../../../constants/common'
import { BUTTON_HEIGHT_20 } from '../../../../Button'
import { DragDropDroppableArea } from '../../../../DragDrop'
import { getCalendarGridDropAreaId } from '../../../CalendarGrid.utils'
import { CalendarGridDayChips } from '../../../CalendarGridDayChips'
import { getIsCalendarGridTodayTinted } from '../../CalendarGridWeek.utils'

import {
  getCalendarGridSingleDayItems,
  getCalendarGridWeekAllDayCellStyle,
  getIsCalendarGridLaneItemDragDisabled,
} from './CalendarGridWeekAllDayCell.utils'

import * as styles from './CalendarGridWeekAllDayCell.module.css'

function CalendarGridWeekAllDayCell({
  canMoveItems,
  className = styles.CalendarGridWeekAllDayCell,
  day,
  dayIndex,
  dayLoad,
  days,
  items,
  spanCount,
  today,
  onClickItem,
  onClickSecondaryLabel,
}) {
  const { laneLabel } = dayLoad ?? EMPTY_OBJECT

  return (
    <DragDropDroppableArea
      className={classNames(className, {
        [styles.today]: getIsCalendarGridTodayTinted({ day, days, today }),
      })}
      data={{ day: day.date }}
      disabled={!canMoveItems}
      id={getCalendarGridDropAreaId(day.date)}
      style={getCalendarGridWeekAllDayCellStyle({ dayIndex, spanCount })}
    >
      <CalendarGridDayChips
        canMoveItems={canMoveItems}
        chipItems={getCalendarGridSingleDayItems(items)}
        day={day.date}
        dayLoad={dayLoad}
        dayLoadLabel={laneLabel}
        getIsItemDragDisabled={getIsCalendarGridLaneItemDragDisabled}
        items={items}
        moreHeight={BUTTON_HEIGHT_20}
        spanCount={spanCount}
        onClickItem={onClickItem}
        onClickSecondaryLabel={onClickSecondaryLabel}
      />
    </DragDropDroppableArea>
  )
}

export default CalendarGridWeekAllDayCell
